// @mui material components
import {createTheme} from "@mui/material/styles";

import borders from "./base/borders";
// Soft UI Dashboard React base styles
import typography from "./base/typography";
// Soft UI Dashboard React helper functions

// export default createTheme({
//     breakpoints: { ...breakpoints },
//     palette: { ...colors },
//     typography: { ...typography },
//     shadows: { ...boxShadows },
//     borders: { ...borders },
//     functions: {
//       boxShadow,
//       hexToRgb,
//       linearGradient,
//       pxToRem,
//       rgba,
//     },

//     components: {
//       MuiButton: { ...button },
//     },
//   });

export default createTheme({
  // shadows: {
  //   ...boxShadows
  // },
  borders: {
    ...borders,
  },

  palette: {
    primary: {
      main: "#414099",
    },
    secondary: {
      main: "#3C7E78",
    },
  },

  typography: {
    ...typography,
  },
});

declare module "@mui/material/styles" {
  interface Theme {
    borders: {
      borderColor: any;
      borderRadius: any;
      borderWidth: any;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    borders?: {
      borderColor?: any;
      borderRadius?: any;
      borderWidth?: any;
    };
  }
}
